import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IUserDataSyncWorkbenchService = ( createDecorator('IUserDataSyncWorkbenchService'));
export { IUserDataSyncWorkbenchService };
